module.exports = __webpack_public_path__ + "static/img/main-tain.ac2b5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main-tain.png
// module id = LWis
// module chunks = 18